import React, {useState, useEffect} from 'react';
import {Flex, Col, Row} from '../common/plain';
import Board from './board';

export const Index = ({}) => {
    return (
        <Board />
    )
};

export default Index;